import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import Product from '../entities/product';
import Ajax from '../../lib/ajaxSub';
import PageResult from '@/store/entities/page-result';

interface ProductState extends ListState<Product> {
    editProduct: Product;
}
class SubstationModule extends ListModule<ProductState, any, Product> {
    public actions = {
        async getProductsByActivitiess(context: ActionContext<ProductState, any>, payload: any) {
            // tslint:disable-next-line:max-line-length
            const reponse = await Ajax.get('/api/services/app/Product/GetProductssByActivities', { params: payload.data });
            return reponse.data.result;
        },
         //活动隔离-满减
         async getProductsByActivitiess_MobileBuyFull(context: ActionContext<ProductState, any>, payload: any) {
            // tslint:disable-next-line:max-line-length
            const reponse = await Ajax.get('/api/services/app/MobileBuyFull/GetProductssByActivities', { params: payload.data });
            return reponse.data.result;
        },
         //活动隔离-拼团
         async getProductsByActivitiess_MobilePintuan(context: ActionContext<ProductState, any>, payload: any) {
            // tslint:disable-next-line:max-line-length
            const reponse = await Ajax.get('/api/services/app/MobilePintuan/GetProductssByActivities', { params: payload.data });
            return reponse.data.result;
        }
    };
}
const substationModule = new SubstationModule();
export default substationModule;
